/* biome-ignore-all lint/correctness/useUniqueElementIds: react-intl message ids are not DOM ids in this component. */
import type { GetProp, UploadProps } from "antd";
import { message, Upload } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { FormattedMessage, useIntl } from "react-intl";

const allowedFileTypes = ["image/png", "image/jpeg"];

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
type Props = {
  handleUpload: (file: FileType) => void;
  disabled: boolean;
};

const ImageUploader = ({ handleUpload, disabled }: Props) => {
  const [messageApi, messagesContextHolder] = message.useMessage();
  const { formatMessage } = useIntl();

  const onBeforeUpload = (file: FileType) => {
    if (!allowedFileTypes.includes(file?.type)) {
      messageApi.error(formatMessage({ id: "image.upload.type.invalid.error" }));
    } else {
      handleUpload(file);
    }
    return false;
  };

  return (
    <>
      {messagesContextHolder}
      <Upload
        disabled={disabled}
        maxCount={1}
        accept={allowedFileTypes.join(",")}
        showUploadList={false}
        beforeUpload={onBeforeUpload}
      >
        <DefaultButton disabled={disabled}>
          <FormattedMessage id="browse" />
        </DefaultButton>
      </Upload>
    </>
  );
};

export default ImageUploader;
